@import '../utils/global.module.less';

.tableContainer {
    // Top spacing is owned by the DealView content container (24px); keep only
    // horizontal padding here so Outputs aligns with the other pages.
    padding: 0 20px;
    position: relative;
}

.outputsTable {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #eaecf0;
    border-radius: 10px;
    overflow: hidden;
    background-color: white;
}

.headerRow {
    background-color: #243a5c;
    color: white;
    font-family: 'Hanken Grotesk', sans-serif;
    font-weight: 600;
    font-size: 14px;

    th {
        padding: 12px 16px;
        border-bottom: 2px solid #1a2d47;

        &:first-child {
            border-top-left-radius: 10px;
        }

        &:last-child {
            border-top-right-radius: 10px;
        }
    }
}

.headerModule {
    text-align: left;
    width: 20%;
}

.headerOutput {
    text-align: left;
    width: 50%;
}

.headerDate {
    text-align: center;
    width: 20%;
}

.headerExport {
    text-align: center;
    width: 10%;
}

.tableRow {
    border-bottom: 1px solid #eaecf0;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: #f9fafb;
    }

    td {
        padding: 16px;
        vertical-align: top;
    }
}

.moduleColumn {
    width: 20%;
    border-right: 1px solid #eaecf0;
}

.moduleName {
    color: #243a5c;
    font-family: 'Hanken Grotesk', sans-serif;
    font-weight: 600;
    font-size: 15px;
}

.outputColumn {
    width: 50%;
    border-right: 1px solid #eaecf0;
}

.outputContainer {
    position: relative;
}

.truncatedContent {
    max-height: 120px;
    overflow: hidden;
    position: relative;
    color: #475467;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 14px;
    line-height: 1.6;

    // Fade effect at bottom
    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1)
        );
        pointer-events: none;
    }

    // Style markdown elements inside preview
    p {
        margin: 4px 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 8px 0 4px 0;
        color: #243a5c;
    }

    ul,
    ol {
        margin: 4px 0;
        padding-left: 20px;
    }

    table {
        font-size: 12px;
        border-collapse: collapse;

        th,
        td {
            border: 1px solid #eaecf0;
            padding: 4px 8px;
        }
    }
}

.expandedContent {
    color: #475467;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 14px;
    line-height: 1.6;

    // Style markdown elements in expanded view
    p {
        margin: 8px 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 16px 0 8px 0;
        color: #243a5c;
    }

    ul,
    ol {
        margin: 8px 0;
        padding-left: 20px;
    }

    table {
        font-size: 12px;
        border-collapse: collapse;
        margin: 12px 0;
        width: 100%;

        th,
        td {
            border: 1px solid #eaecf0;
            padding: 8px;
        }

        th {
            background-color: #f9fafb;
            font-weight: 600;
        }
    }
}

.truncateIndicator {
    color: #98a2b3;
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 8px;
}

.toggleButton {
    color: #0066cc;
    background: none;
    border: none;
    padding: 8px 0;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 8px;

    &:hover {
        text-decoration: underline;
        color: #0052a3;
    }

    &:active {
        color: #003d7a;
    }
}

.emptyStateCell {
    padding: 0 !important;
}

.emptyState {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 64px 16px;
    gap: 12px;
}

.emptyStateVideo {
    width: 72px;
    height: 72px;
    object-fit: contain;
    // Purely decorative — block hover controls / PiP button entirely.
    pointer-events: none;

    &::-webkit-media-controls,
    &::-webkit-media-controls-enclosure,
    &::-webkit-media-controls-panel {
        display: none !important;
    }
}

.emptyStateText {
    color: #98a2b3;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 15px;
    font-weight: 500;
}

.dateColumn {
    width: 20%;
    text-align: center;
    color: #475467;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 14px;
}

.exportColumn {
    width: 10%;
    text-align: center;
    color: #475467;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 14px;
}
